import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const RadiusModalSlide: FC = () => {
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiCountDownFontURL = getFontURL(fontFamily?.multi_countdown);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url('${multiTitleFontURL}');
  }
  @font-face {
    font-family: 'multiCountdown';
    src: url('${multiCountDownFontURL}');
  }
  @font-face {
    font-family: 'countdownTitle';
    src: url('${countdownTitleFontURL}');
  }
  @font-face {
    font-family: 'multiButton';
    src: url('${multiButtonFontURL}');
  }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      position: relative;
      overflow: hidden;
      background: none;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 1rem;
  
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
  
      overflow: hidden;
      background-color: transparent;
    }

    .contents_wrapper {
      padding: 0 10%;
    }
    .contents_wrapper .title {
      width: 100%;
      height: 2.5rem;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12.5rem;
    }
    
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 15rem;
      height: 10rem;
      outline: none;
      border-radius: ${radius?.multi_image}px;
    }
    .slick_wrapper .slick-track img {
      object-flt: cover;
    }
    .slick_wrapper .slick-track {
      display: flex;
      margin-left: 10%;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick_wrapper .slick-slide {
      margin-right: 1rem;
    }
    .slick_wrapper .slick-list {
      margin-right: -1rem;
    }

    .slick_wrapper .countdown {
      width: 100%;
      max-height: 1.5rem;
      margin-top: 0.5rem;

      display: flex;
      justify-content: end;
      align-items: center;

      color: ${color?.multi_countdown};
      font-size: ${fontSize?.multi_countdown}rem;
      font-weight: ${fontWeight?.multi_countdown};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_countdown
        )
          ? fontFamily?.multi_countdown
          : 'multiCountdown'
      };
    }
    .countdown_title {
      max-height: 1.5rem;
      margin-right: 0.5rem;

      display: flex;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.countdown_title]};
      align-items: center;

      color: ${color?.countdown_title};
      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitle'
      };
    }
    .countdown_content {
      height: 2rem;
      display: grid;
      grid-template-columns: 2.5rem 0.5rem 2.5rem 0.5rem 2.5rem;
      gap: 0.25rem;

      color: ${color?.multi_countdown};
      font-size: ${fontSize?.multi_countdown}rem;
      font-weight: ${fontWeight?.multi_countdown};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiButton'
      };
    }
    .countdown_content div {
      display: flex;
      align-items: center;
    }
    .countdown_content .time {
      max-width: 2.5rem;
      max-height: 2rem;
      justify-content: center;
      text-align: center;
    }
    .countdown_content .divider {
      max-width: 0.5rem;
      max-height: 2rem;
    }

    .bottom_wrapper {
      width: 100%;
      height: 2rem;
      padding: 0 10%;

      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .bottom_wrapper .bar {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: start;
      align-items: center;
      text-align: left;
    }
    #bar_box {
      min-width: 7rem;
      max-width: 7rem;
      max-height: 0.125rem;
      min-height: 0.125rem;

      border-radius: 999px;
      background-color: #777777;
    }
    #bar_index {
      max-height: 0.125rem;
      min-height: 0.125rem;
      position: absolute;
      border-radius: 999px;
      background-color: #ffffff;
      transition: all ease 0.2s;
    }
    .bottom_wrapper .button {
      width: 100%;
      height: 100%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      justify-content: end;
      align-items: center;
      text-align: right;

      color: ${btnColor?.multi_button};
      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      font-family: ${btnFontFamily?.multi_button};
      background-color: rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    .close_btn {
      text-align: center;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      margin-top: 2rem;
      
      font-size: 0;
      border: none;

      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;
      background-color: transparent;
    }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .contents_wrapper {
        padding: 0 25%;
      }
      .contents_wrapper .title {
        height: 3rem;
        font-size: ${fontSize?.multi_title + 0.375}rem;
      }

      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        width: 100%;
        height: 17.5rem;
      }
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        width: 24rem;
        height: 15rem;
      }
      .slick_wrapper .slick-track {
        margin-left: 25%;
      }
      .slick_wrapper .slick-slide {
        margin-right: 2rem;
      }
      .slick_wrapper .slick-list {
        margin-right: -2rem;
      }

      .slick_wrapper .countdown {
        max-height: 3rem;
        font-size: ${fontSize?.countdown_title + 0.375}rem;
      }
      .countdown_title {
        max-height: 2rem;
        margin-right: 1.5rem;
      }
      .countdown_content {
        height: 3rem;
        display: grid;
        grid-template-columns: 3rem 0.5625rem 3rem 0.5625rem 3rem;
        gap: 0.25rem;

        font-size: ${fontSize?.multi_countdown + 0.25}rem;
      }
      .countdown_content .time {
        max-width: 3rem;
        max-height: 3rem;
      }
      .countdown_content .divider {
        max-width: 3rem;
        max-height: 3rem;
      }

      .bottom_wrapper {
        height: 2rem;
        padding: 0 25%;
      }
      #bar_box {
        min-width: 10rem;
        max-width: 10rem;
      }
      .bottom_wrapper .button {
        font-size: ${btnFontSize?.multi_button + 0.25}rem;
      }

      .close_btn button {
        margin-top: 4rem;
      }
    }
  `;

  const html =
    `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="contents_wrapper">
          <div class="contents_slider">` +
    text?.multi_title
      ?.map((data: any, idx: number) => {
        return `
        <div class="title">
          ${changeEnterHTML(text?.multi_title?.[idx])}
        </div>`;
      })
      .join('') +
    `
          </div>
        </div>
        <div class="slick_wrapper">
          <div class="slick_slider">` +
    text?.multi_title
      ?.map((data: any, idx: number) => {
        return `
        <div>
          <img
            class="image"
            src="${bgImage?.multi_image?.[idx]}"
            alt="modal paging slide"
          />
          <div class="countdown">
            <div class="countdown_title">
              ${changeEnterHTML(text?.countdown_title)}
            </div>
            <span class="timer countdown_content">
              <div id="cDay${idx}" class="time">00</div>
              <div class="divider">:</div>
              <div id="cHour${idx}" class="time">00</div>
              <div class="divider">:</div>
              <div id="cMin${idx}" class="time">00</div>
            </span>
          </div>
        </div>
      `;
      })
      .join('') +
    `
          </div>
        </div>
        <div>
          <div class="bottom_wrapper">
            <div class="bar">
            ${
              bgImage?.multi_image?.length !== 1
                ? `
                <div id="bar_box"></div>
                <div id="bar_index"></div>
              `
                : ``
            }
            </div>
            <div class="button"></div>
          </div>
          <div class="close_btn">
            <button>close</button>
          </div>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = `[`;
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = `[`;
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `'${btnText?.multi_button?.[i]}'`;
    if (i !== btnText?.multi_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.multi_sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList(
    'RADIUS MODAL SLIDE',
    button1,
    button2
  );

  const js =
    `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: false,
        infinite: false,
        dots: false,
    
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        touchThreshold: 300
      });
  
      $('.contents_slider').slick({
        arrows: false,
        infinite: false,
        fade: true,
        speed: 300,
        swipe: false
      });

      let currentIndex = 0;
      let button = ${button_list};
      $('#bar_box').css('width', 7 + 'rem');
      $('#bar_index').css(
        'width',
        ((currentIndex + 1) / ${bgImage?.multi_image?.length}) *
          (window.innerWidth > 767 ? 10 : 7) +
          'rem'
      );
      $('.button').text(button[currentIndex]);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.contents_slider').slick('goTo', currentIndex);
        $('#bar_box').css('width', 7 + 'rem');
        $('#bar_index').css(
          'width',
          ((currentIndex + 1) / ${bgImage?.multi_image?.length}) *
            (window.innerWidth > 767 ? 10 : 7) +
            'rem'
        );
        $('.button').text(button[currentIndex]);
      });

      let deeplink = ${deeplink_list};
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.image').click(function() {
        appboyBridge.logClick(tracking[currentIndex][0]);
        try {
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.button').click(function() {
        appboyBridge.logClick(tracking[currentIndex][1]);
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.close_btn').click(function() {
        appboyBridge.logClick(tracking[currentIndex][2]);
        try {
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });

      // 남은시간 계산해주는 함수
      const countdownTimer = function(id1, id2, id3, id4, date){
        let _vData = date;
        let _second = 1000;
        let _minute = _second * 60;
        let _hour = _minute * 60;
        let _day = _hour * 24;
        let timer;
    
        function showRemaining(){
          let now = new Date();
          let distDt = _vData - now;
    
          if(distDt < 0){
            clearInterval(timer);
            document.getElementById(id4).textContent = 
            '종료되었습니다.';
            $('.timer').addClass('finish_ment');
            return;
          }
    
          let days = Math.floor(distDt / _day);
          let hours = Math.floor((distDt % _day) / _hour + (days * 24));
          let minutes = Math.floor((distDt % _hour) / _minute);
          let seconds = Math.floor((distDt % _minute) / _second);
    
          document.getElementById(id1).textContent = String(hours).padStart(2, "0");
          document.getElementById(id2).textContent = String(minutes).padStart(2, "0");
          document.getElementById(id3).textContent = String(seconds).padStart(2, "0");
          // document.getElementById(id).textContent += seconds + '초'; 
        }
    
        timer = setInterval(showRemaining, 1000)
      }
  
      ` +
    text?.multi_countdown
      ?.map((_: any, idx: number) => {
        return `
        countdownTimer("cDay${idx}", "cHour${idx}", "cMin${idx}", "timer", new Date(${text?.multi_countdown?.[idx]?.year},${text?.multi_countdown?.[idx]?.month}-1,${text?.multi_countdown?.[idx]?.date},${text?.multi_countdown?.[idx]?.hour},${text?.multi_countdown?.[idx]?.min}))
        `;
      })
      .join('') +
    `

    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
        />

        {/* jquery */}
        <script
          id="test"
          src="https://code.jquery.com/jquery-3.6.0.min.js"
        ></script>
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        ></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.countdown/2.2.0/jquery.countdown.min.js"></script>
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};

export default RadiusModalSlide;
